import axios from "axios";

export const baseURL = `${process.env.REACT_APP_INMASTER_APP_API_HOST}`;

const axiosInstance = axios.create({
  baseURL,
});

export { axiosInstance };
